import { GetSpaceBase } from '../types/GetSpaceBase';
import { fillUtilityProps } from '../utils/fillUtilityProps';
import { isUndefinedSpace } from '../utils/isUndefinedSpace';
import { prepareInnerContext } from '../utils/prepareInnerContext';
import { getSpaceByEntity } from './getSpaceByEntity';
import { getSpaceGeneral } from '../entities/general/getSpaceGeneral';

const getSpacePrev: GetSpaceBase = (
  group,
  space,
  context,
  extra,
) => {
  const contextInner = prepareInnerContext(context);

  // first try to get key by entity
  const byEntity = getSpaceByEntity(group, space, contextInner, extra);
  if (!isUndefinedSpace(byEntity)) return byEntity;

  // then search in general
  return getSpaceGeneral(group, space, contextInner, extra);
};

export const getSpace: GetSpaceBase = (
  group,
  space,
  context,
  extra,
) => {
  const res = getSpacePrev(group, space, context, extra);
  return fillUtilityProps(res);
};
